import { createSelector } from '@ngrx/store';
import { AppState } from '../app.state';

export const selectSuperEditMode = createSelector(
  (state: AppState) => state.userSettings,
  s => s.superEditMode
);

export const selectDevMode = createSelector(
  (state: AppState) => state.userSettings,
  s => s.devMode
);

export const selectSupportMode = createSelector(
  (state: AppState) => state.userSettings,
  s => s.supportMode
);

export const selectUserSettings = createSelector(
  (state: AppState) => state.userSettings,
  s => s
);

export const selectHiddenFieldsMode = createSelector(
  (state: AppState) => state.userSettings,
  s => s.showHiddenFields
);
